import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
  Col,
  Button,
  Text,
  Spacer,
  Layout,
} from 'athenaeum';

import styles from './main-content.module.scss';
import Resource from './Resource';
import { resourcesList, buttons } from '../data/resources';
import { RESOURCES } from '../constants';
import SelectProductModal from './SelectProductModal';

class SelectProduct extends React.Component {
  constructor(props) {
    super(props);

    if (!this) {
      /* eslint-disable no-console */
      console.log("'this' was undefined.");
      /* eslint-enable no-console */
      return null;
    }

    this.state = {
      modalIsOpen: false
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    if (!this) {
      /* eslint-disable no-console */
      console.log("'this' was undefined.");
      /* eslint-enable no-console */
      return null;
    }

    this.setState({
      modalIsOpen: true
    });

    return null;
  }

  closeModal() {
    this.setState({
      modalIsOpen: false
    });
  }

  /* eslint-disable class-methods-use-this */
  componentDidCatch(error, info) {
    /* eslint-disable no-console */
    console.log('Error Boundary', error, info);
    /* eslint-enable no-console */
  }
  /* eslint-enable class-methods-use-this */

  render() {
    if (!this) {
      /* eslint-disable no-console */
      console.log("'this' was undefined.");
      /* eslint-enable no-console */
      return null;
    }

    const { className } = this.props;

    const modalProps = {
      header: 'Get a Quote',
      onRequestClose: this.closeModal,
      isOpen: this.state.modalIsOpen
    };

    return (
      <Layout
        className={cx(styles['main-content'], className)}
        mediumCols={[6]}
        largeCols={[4, 5, 3]}
        nested
      >
        <Col className={styles['select-product-1']} >
          <Text type={7} font="a">What kind of insurance are you looking for?</Text>
          <Spacer size={6} />
          <Text type={10} font="b" italic>Get your free quote</Text>
          <Spacer size={18} />
          <Button
            variant="info"
            outline
            unflex
            onClick={this.openModal}
            className={styles.button}
          >
            { buttons.selectProductButton.text }
          </Button>
          <SelectProductModal modalProps={modalProps} />
        </Col>
        <Resource
          resources={resourcesList[RESOURCES.INSURANCE_GUIDES]}
        />
        <Resource
          resources={resourcesList[RESOURCES.GENIUS_CENTER]}
        />
        <Col className={styles['select-product-2']} >
          <Text type={7} font="a">Want to receive weekly life hacks & personal finance advice?</Text>
          <Spacer size={18} />
          <Button
            variant="info"
            outline
            unflex
            data-sumome-listbuilder-id="b25d109e-ee6c-4d4a-b966-02932ea6df8d"
            className={styles.button}
          >
            { buttons.newsletterButton.text }
          </Button>
        </Col>
        <Resource
          resources={resourcesList[RESOURCES.HELPFUL_RESOURCES]}
        />
        <Resource
          resources={resourcesList[RESOURCES.REVIEWS]}
        />
        <Resource
          className={styles['last-resource']}
          resources={resourcesList[RESOURCES.ABOUT]}
        />
      </Layout>
    );
  }
}

SelectProduct.propTypes = {
  className: PropTypes.string
};

export default SelectProduct;



// WEBPACK FOOTER //
// ../src/templates/Footer/MainContent/index.js